import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Bolt } from '@mui/icons-material';
import { useLanguage } from '../../i18n/LanguageContext';
import { NodeCardShell } from './NodeCardShell';
import { NodeCardProps } from './NodeCardProps';

export const SmartPlugNodeCard: React.FC<NodeCardProps> = ({
  node, index, onToggle, onEditOpen,
}) => {
  const { t } = useLanguage();
  const s = node.settings ?? {};

  const handleOn  = () => { if (node.state !== true)  onToggle(); };
  const handleOff = () => { if (node.state !== false) onToggle(); };

  return (
    <NodeCardShell node={node} index={index} onEditOpen={onEditOpen}>
      <Box display="flex" gap={1} mb={s.power !== undefined || s.energyToday !== undefined ? 1.5 : 0}>
        <Button
          variant={node.state !== true ? 'contained' : 'outlined'}
          color={node.state === false ? 'error' : 'inherit'}
          size="small" onClick={handleOff} disabled={node.isLoading} sx={{ flex: 1 }}
        >
          {t.statusOff}
        </Button>
        <Button
          variant={node.state === true ? 'contained' : 'outlined'}
          color={node.state === true ? 'success' : 'inherit'}
          size="small" onClick={handleOn} disabled={node.isLoading} sx={{ flex: 1 }}
        >
          {t.statusOn}
        </Button>
      </Box>

      {(s.power !== undefined || s.energyToday !== undefined) && (
        <Box display="flex" alignItems="center" gap={1}>
          <Bolt fontSize="small" color="warning" />
          {s.power !== undefined && (
            <Typography variant="body2">
              {t.smartPlugPower}: <strong>{s.power} W</strong>
            </Typography>
          )}
          {s.energyToday !== undefined && (
            <Typography variant="body2" color="text.secondary">
              · {t.smartPlugToday}: {s.energyToday.toFixed(2)} kWh
            </Typography>
          )}
        </Box>
      )}
    </NodeCardShell>
  );
};
